@if((languageService.loadingIndicator$ | async) === 0){
  @if(showTopMenu()) {
    <app-bar-top></app-bar-top>
  }
  @if(showBarIcons()) {
    <app-bar-icons></app-bar-icons>
  }
  <router-outlet></router-outlet>
  <app-global-footer></app-global-footer>
  <app-emoji-picker></app-emoji-picker>
  @if(documentService.documentsGalleryDialog){
    <app-dialog-documents-gallery
      [visible]="documentService.documentsGalleryDialog"
      [hideReactions]="documentService.documentsGalleryHideReactions"
      [showChatOptions]="documentService.documentsGalleryShowChatOptions"
      (visibleChange)="documentService.documentsGalleryDialog = $event; documentService.documentsGalleryHideReactions = false; documentService.documentsGalleryMessageId = 0; documentService.documentsGalleryFileToMessageMap.clear(); documentService.documentsGalleryForwardDialog = false; documentService.documentsGalleryShowChatOptions = false"
      >
    </app-dialog-documents-gallery>
  }
  @if(documentService.documentsGalleryForwardDialog){
    <app-dialog-chat-forward
      [visible]="documentService.documentsGalleryForwardDialog"
      (visibleChange)="documentService.documentsGalleryForwardDialog = $event">
    </app-dialog-chat-forward>
  }
  @if(profileService.profileAvatarDialog()){
    <app-dialog-profile-avatar
      [visible]="profileService.profileAvatarDialog()"
      (visibleChange)="profileService.profileAvatarDialog.set($event)"
      >
    </app-dialog-profile-avatar>
  }
  <div class="dialogs"></div>
}
<app-loading-indicator></app-loading-indicator>
